module.exports = ".flex{display:flex;margin-top:2px}\n"